import { NavLink } from 'react-router-dom'
import confirmDelete from 'shared/utils/confirmDelete'
import * as Icon from 'react-bootstrap-icons'
import getAll from 'utils/getAll'
import { apiUrls, roles } from 'consts'
import hasAnyRole from 'shared/utils/hasAnyRole'
import ActionButtons from 'shared/components/ActionButtons'

interface getRowsProps {
  setDeleteEntryId: Function
  setShowModal: Function
}

const getRows = async (props: getRowsProps) => {
  let data = await getAll(apiUrls.centers)

  const canEditAndDelete = hasAnyRole([roles.admin, roles.superAdmin])

  data.forEach((row: any, index: number, dataArray: any) => {
    if (canEditAndDelete) {
      dataArray[index].action = <ActionButtons buttons={[
        {
          type: 'u',
          url: '/edit-center/' + row.id
        },
        {
          type: 'd',
          id: dataArray[index].id,
          url: '/delete-center/' + row.id,
          setDeleteEntryId: props.setDeleteEntryId,
          setShowModal: props.setShowModal
        }
      ]} />
    }

    dataArray[index].site = dataArray[index].site?.name
  })

  return data
}

export default getRows
